import { createBrowserRouter } from 'react-router-dom'

import App, { loader as appLoader } from './components/App/App'
import Track, { loader as trackLoader } from './components/Track/Track'

export default createBrowserRouter([
  {
    path: '/',
    element: <App/>,
    loader: appLoader,
    children: [
      {
        path: ':artist/:album/:track',
        element: <Track/>,
        loader: trackLoader,
      },
    ],
  },
])
